<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import DateRangeMixin from "@/mixins/DateRangeMixin";
import DepartmentService from "@/services/DepartmentService";
import VFilters from "@/components/Search/VFilters";
import MessagesMixin from "@/mixins/Messages";
import DaylogService from "@/services/DaylogService";
import VMissingDays from "@/views/Reports/components/VMissingDays";
import InnerDashCard from "@/components/Cards/InnerDashCard";
import HalfDashCard from "@/components/Cards/HalfDashCard";

export default {
    name: "VPersonalMultiview",
    mixins: [DateRangeMixin, MessagesMixin],
    components: {
        VFilters,
        DateRangePicker,
        VMissingDays,
        InnerDashCard,
        HalfDashCard
    },
    data() {
        return {
            loading: true,
            stats: {},
            range: []
        };
    },
    async created() {
        this.resetSearch();
        this.$apiEnableWatcher();
        await this.fetchData();
    },
    methods: {
        async fetchData() {
            if (this.apiSearchFilter.dateRange.startDate === null) {
                this.loading = false;
                return;
            }

            try {
                this.loading = true;
                let params = this.$buildParams();
                const { data } = await DaylogService.GET_myReport(params);
                this.stats = data.data;
                this.range = this.stats.range;
            } catch (e) {
                console.log("e fetchData", e);
            }

            this.loading = false;
        },
        resetSearch() {
            this.apiSearchFilter = {
                dateRange: {
                    startDate: null,
                    endDate: null
                }
            };
        }
    }
};
</script>

<template>
    <div class="v-my-report">
        <base-header class="pb-1" type=""><bread-bag></bread-bag></base-header>
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <card body-classes="px-4">
                        <!-- V-FILTERS -->
                        <div class="px-0 mb-4">
                            <v-filters
                                :search="false"
                                :start-open="true"
                                :enable-filters="true"
                                @reset-search="resetSearch"
                                @filter-view-change="$handleFilterView($event)"
                            >
                                <!-- Default slot starts here -> filters -->
                                <div class="col-12 col-md-3">
                                    <date-range-picker
                                        class="range-picker"
                                        ref="picker"
                                        opens="right"
                                        :timePicker="false"
                                        :showWeekNumbers="true"
                                        :autoApply="true"
                                        v-model="apiSearchFilter.dateRange"
                                        :linkedCalendars="true"
                                        :locale-data="
                                            getDateRangePickerLocale()
                                        "
                                        :ranges="getDateRangePickerRanges()"
                                    >
                                        <template #header>
                                            <manual-range
                                                :date-range-manual="
                                                    dateRangeManual
                                                "
                                                :date-range-error="
                                                    dateRangeError
                                                "
                                                @exec="
                                                    execManualRange(
                                                        'apiSearchFilter',
                                                        'dateRange'
                                                    )
                                                "
                                            />
                                        </template>
                                        <template
                                            v-slot:input="picker"
                                            style="min-width: 350px"
                                        >
                                            <template v-if="picker.startDate">
                                                {{
                                                    $d(
                                                        picker.startDate,
                                                        "short"
                                                    )
                                                }}
                                                -
                                                {{
                                                    $d(picker.endDate, "short")
                                                }}
                                            </template>
                                        </template>
                                    </date-range-picker>
                                </div>

                                <div
                                    class="col-12 mt-3"
                                    v-if="
                                        apiSearchFilter.dateRange.startDate ===
                                            null
                                    "
                                >
                                    <div class="text-bold text-warning">
                                        {{
                                            $t(
                                                "personal_multiview.warn_select_dates"
                                            )
                                        }}
                                    </div>
                                </div>
                            </v-filters>
                        </div>

                        <!-- BODY -->
                        <hr />
                        <v-loader :loading="loading" v-if="loading" />
                        <div v-else-if="range.length > 0">
                            <div class="row">
                                <!-- Left side gen stats -->
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col">
                                            <inner-dash-card
                                                icon="far fa-clock"
                                                :title="
                                                    $t(
                                                        'clock_report.total_registered_time'
                                                    )
                                                "
                                                >{{
                                                    stats.total_work_time
                                                        | toTime
                                                }}</inner-dash-card
                                            >
                                        </div>
                                        <div class="col">
                                            <inner-dash-card
                                                icon="far fa-user-slash"
                                                :title="
                                                    $t(
                                                        'clock_report.total_absence_time'
                                                    )
                                                "
                                                >{{
                                                    stats.total_absence_time
                                                        | toTime
                                                }}</inner-dash-card
                                            >
                                        </div>
                                        <div class="col">
                                            <inner-dash-card
                                                icon="far fa-bullseye"
                                                :title="
                                                    $t(
                                                        'clock_report.total_goal'
                                                    )
                                                "
                                            >
                                                {{
                                                    stats.total_goal | toTime
                                                }}</inner-dash-card
                                            >
                                        </div>
                                        <div class="col">
                                            <inner-dash-card
                                                icon="far fa-balance-scale"
                                                :title="
                                                    $t(
                                                        'clock_report.total_balance'
                                                    )
                                                "
                                                ><span
                                                    :class="{
                                                        'text-danger':
                                                            stats.total_balance <
                                                            0
                                                    }"
                                                    ><span
                                                        v-if="
                                                            stats.total_balance <
                                                                0
                                                        "
                                                        >-</span
                                                    >{{
                                                        stats.total_balance
                                                            | toTime
                                                    }}</span
                                                ></inner-dash-card
                                            >
                                        </div>
                                        <div class="col">
                                            <inner-dash-card
                                                icon="far fa-bullseye-arrow"
                                                :title="
                                                    $t(
                                                        'clock_report.daily_goal'
                                                    )
                                                "
                                                >{{
                                                    stats.daily_goal | toTime
                                                }}</inner-dash-card
                                            >
                                        </div>
                                    </div>
                                </div>
                                <!-- Right side detailed -->
                                <div class="col-12">
                                    <v-table
                                        class="table table-sm table-striped table-bordered missing-days-table"
                                    >
                                        <v-thead>
                                            <v-tr>
                                                <v-th>{{
                                                    $t(
                                                        "missing_days_modal.date"
                                                    )
                                                }}</v-th>
                                                <v-th>{{
                                                    $t(
                                                        "missing_days_modal.day_of_week"
                                                    )
                                                }}</v-th>
                                                <v-th class="text-right">{{
                                                    $t(
                                                        "missing_days_modal.registered_time"
                                                    )
                                                }}</v-th>
                                                <v-th class="text-right">{{
                                                    $t(
                                                        "missing_days_modal.absence_time"
                                                    )
                                                }}</v-th>
                                                <v-th class="text-right">{{
                                                    $t(
                                                        "missing_days_modal.total_real_time"
                                                    )
                                                }}</v-th>
                                                <v-th class="text-right">{{
                                                    $t(
                                                        "personal_multiview.time_balance"
                                                    )
                                                }}</v-th>
                                            </v-tr>
                                        </v-thead>
                                        <v-tbody>
                                            <v-tr
                                                v-for="d in range"
                                                :key="d.date"
                                                :class="
                                                    d.business_day
                                                        ? `day-type-business`
                                                        : `day-type-free`
                                                "
                                            >
                                                <v-td>{{
                                                    $d(
                                                        new Date(d.date),
                                                        "short"
                                                    )
                                                }}</v-td>
                                                <v-td>{{
                                                    $d(new Date(d.date), "ldow")
                                                }}</v-td>
                                                <v-td class="text-right">{{
                                                    d.work_time | toTime
                                                }}</v-td>
                                                <v-td class="text-right">{{
                                                    d.absence_time | toTime
                                                }}</v-td>
                                                <v-td class="text-right">{{
                                                    d.real_time | toTime
                                                }}</v-td>
                                                <v-td
                                                    class="text-right"
                                                    :class="{
                                                        'text-danger':
                                                            d.business_day &&
                                                            d.balance < 0
                                                    }"
                                                >
                                                    <template
                                                        v-if="d.business_day"
                                                    >
                                                        <span
                                                            v-if="d.balance < 0"
                                                            >-</span
                                                        >
                                                        {{ d.balance | toTime }}
                                                    </template>
                                                    <template v-else
                                                        >({{
                                                            $t(
                                                                "missing_days_modal.free_day"
                                                            )
                                                        }})</template
                                                    ></v-td
                                                >
                                            </v-tr>
                                        </v-tbody>
                                    </v-table>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
        <portal to="modals"> </portal>
    </div>
</template>

<style lang="scss">
.v-my-report {
    dl {
        dt {
            font-weight: normal;
        }

        dd {
            font-size: 25px;
            font-weight: 600;
            margin-bottom: 20px;
        }
    }
}
</style>
